/* istanbul ignore file */
import setupPageState from './PageState';

function bootstrap() {
    //can maybe remove this, safari <= 10
    window.performance = window.performance || {};
    window.performance.clearMarks = window.performance.clearMarks || function () {};
    window.performance.mark = window.performance.mark || function () {};
    window.performance.measure = window.performance.measure || function () {};

    setupKruxInterchange();

    setupPageState(window, document);
}

function setupKruxInterchange() {
    window.Krux || ((window.Krux = function () {
        window.Krux.q.push(arguments);
    }).q = []);

    function retrieve(n) {
        var m, k = 'kx' + n;
        if (window.localStorage) {
            return window.localStorage[k] || "";
        } else if (navigator.cookieEnabled) {
            m = document.cookie.match(k + '=([^;]*)');
            return (m && unescape(m[1])) || "";
        } else {
            return '';
        }
    }

    window.Krux.user = retrieve('user');
    window.Krux.segments = retrieve('segs') && retrieve('segs').split(',') || [];
}

export default {
    bootstrap
};
